module.exports = __webpack_public_path__ + "img/8.fc204493.png";